export enum DependencyTrackPlatform {
  GITEA = 'gitea',
  AZURE_DEVOPS = 'azure'
}